import { Typography, TypographyProps } from '@mui/material';
import { getLLDate } from '@retail/utils';
import { StackedTextCell } from '@retail/components';

interface Props extends TypographyProps {
  validFrom?: Date;
  validTo?: Date;
}

export const DateRange = ({ validFrom, validTo, ...props }: Props) => (
  <StackedTextCell
    topLine={
      <Typography variant="body3" {...props}>
        {getLLDate(validFrom)}
        {validTo ? ' -' : ' →'}
      </Typography>
    }
    nullableBottomLine
    bottomLine={
      validTo && (
        <Typography variant="body3" {...props}>
          {getLLDate(validTo)}
        </Typography>
      )
    }
  />
);
